import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from './shared/locales/en/translation.json';
import translationUA from './shared/locales/ua/translation.json';
import translationRU from './shared/locales/ru/translation.json';


// the translations
const resources = {
  en: {
    translation: translationEN
  },
  ua: {
    translation: translationUA
  },
  ru: {
    translation: translationRU
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    defaultNS: 'translation',
    ns: 'translation',
    fallbackLng: 'en',
    debug: true,
    interpolation: {
      escapeValue: false,
    },
    react: {
			wait: true,
		},
  });

export default i18n;
